import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Icon } from "../../components/Icon/Icon";
import Close from "../../icons/close.svg";
import styles from "./CloseButton.module.scss";
export const CloseButton = memo(({ onClick, className = "", dataTestId = "closeButton" }) => {
    return (_jsx("div", { className: `${styles.close} ${className}`, role: "button", onClick: onClick, "data-testid": dataTestId, children: _jsx(Icon, { component: Close, width: "21px", height: "21px" }) }));
});
//# sourceMappingURL=CloseButton.js.map